<template>
  <div>
    <v-row justify="center pt-3">
      <v-col cols="12" sm="12" md="12" lg="12" class="pa-2 pb-0">
        <!-- row 2 -->
        <v-form ref="AddressForm" lazy-validation @submit.prevent="submit">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-text-field color="primarytext" persistent-placeholder v-model="tempAddressObj.title" class="ma-0"
                label="Title" outlined clearable dense>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-text-field color="primarytext" :rules="[...required, noSpecialCharRule]" persistent-placeholder v-model="tempAddressObj.last"
                class="ma-0" label="Name" outlined clearable dense>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-text-field color="primarytext" persistent-placeholder v-model="tempAddressObj.store" class="ma-0"
                label="Store/Site/Id" outlined clearable dense>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-text-field color="primarytext" :rules="[...required, noSpecialCharRule]" persistent-placeholder
                v-model="tempAddressObj.company" class="ma-0" label="Company Name" outlined clearable dense>
              </v-text-field>
            </v-col>
          </v-row>
          <!-- Row 3 -->
          <v-row>
            <!-- Adddress 1 -->
            <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-text-field color="primarytext" :rules="addressRule" persistent-placeholder
                v-model="tempAddressObj.address1" class="ma-0" label="Address1" outlined clearable dense>
              </v-text-field>
            </v-col>
            <!-- Address 2 -->
            <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-text-field color="primarytext" :rules="address2Rule" v-model="tempAddressObj.address2" persistent-placeholder class="ma-0"
                label="Address2" outlined clearable dense >
              </v-text-field>
            </v-col>
            <!-- City -->
            <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-text-field color="primarytext" :rules="[...required, noSpecialCharRule]" persistent-placeholder v-model="tempAddressObj.city"
                label="City" class="ma-0" outlined clearable dense>
              </v-text-field>
            </v-col>
          </v-row>
          <!-- Row 4 -->
          <v-row>
            <!-- State -->
            <v-col v-if="showStateDrop" cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-autocomplete color="primarytext" :rules="required" persistent-placeholder
                v-model="tempAddressObj.state" class="ma-0" :items="stateData" item-text="States" label="State" outlined
                item-value="StateKey" dense>
              </v-autocomplete>
            </v-col>
            <!-- State if dropdown is empty -->
            <v-col v-else cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-text-field color="primarytext" persistent-placeholder :rules="stateRule"
                v-model="tempAddressObj.state" class="ma-0" label="State" name="State" outlined clearable dense
                @input="tempAddressObj.state = tempAddressObj.state?.toUpperCase()">
              </v-text-field>
            </v-col>
            <!-- zip -->
            <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-text-field color="primarytext" persistent-placeholder :rules="phoneRules" v-model="tempAddressObj.zip"
                label="Zip Code" outlined class="ma-0" clearable dense
                >
              </v-text-field>
            </v-col>
            <!-- COuntry -->
            <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-autocomplete ref="countryAutocomplete" :menu-props="{ maxHeight: 150 }" color="primarytext" persistent-placeholder
                :rules="required" outlined v-model="tempAddressObj.country_id" :items="countryData"
                item-text="country" item-value="country_id" label="Country" dense class="ma-0"
                @change="countrySelected()">
              </v-autocomplete>
            </v-col>
          </v-row>
          <!-- Row 5 -->
          <v-row>
            <!-- phone11 1 -->
            <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-text-field color="primarytext" persistent-placeholder
                :rules="tempAddressObj?.phone1?.length > 0 || tempAddressObj?.cell?.length > 0 ? phoneRules : ''" v-model="tempAddressObj.phone1"
                class="ma-0" label="Phone1" outlined clearable dense >
              </v-text-field>
            </v-col>
            <!-- phone1 2 -->
            <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-text-field color="primarytext" persistent-placeholder v-model="tempAddressObj.phone2" class="ma-0"
                label="Phone2" outlined clearable dense :rules="tempAddressObj?.phone2?.length>0?phoneRules:''">
              </v-text-field>
            </v-col>
            <!-- Fax -->
            <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-text-field color="primarytext" persistent-placeholder v-model="tempAddressObj.fax" class="ma-0"
                label="Fax" outlined :rules="tempAddressObj?.fax?.length>0?phoneRules:''" clearable dense>
              </v-text-field>
            </v-col>
          </v-row>
          <!-- Row 6 -->
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-text-field color="primarytext" persistent-placeholder
                :rules="tempAddressObj?.phone1?.length > 0 || tempAddressObj?.cell?.length > 0 ? [] : phoneRules" v-model="tempAddressObj.cell"
                class="ma-0" label="Cell" outlined clearable dense>
              </v-text-field>
            </v-col>
            <!-- Intaddr -->
            <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-text-field color="primarytext" persistent-placeholder :rules="intaddrRule"
                v-model="tempAddressObj.intaddr" class="ma-0" label="Email Address" outlined clearable dense
                placeholder="XXXX.XXXX@XXXX.COM"
                @input="checkEmailClear">
              </v-text-field>
            </v-col>
          </v-row>
          <!-- ROw 7 -->
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="8" class="px-5 py-0">
              <v-combobox v-model="tempAddressObj.additional_email" color="primarytext" label="Additional Email (Max 10)" multiple
                small-chips deletable-chips clearable outlined dense persistent-placeholder class="ma-0"
                :rules="[additionalEmailChipRule]" hide-selected :menu-props="{ maxHeight: 150 }"
                :disabled="!tempAddressObj.intaddr || tempAddressObj.intaddr.length === 0"
                @input="normalizeAdditionalEmails">
                <template v-slot:selection="{ item, parent }">
                  <v-chip label small color="primary" class="ma-1">
                    <span class="pr-2">{{ item }}</span>
                    <v-icon small @click="parent.selectItem(item)">$delete</v-icon>
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
          </v-row>
          <!--Row 8-->
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-autocomplete :menu-props="{ maxHeight: 150 }" color="primarytext" persistent-placeholder
                :rules="required" outlined v-model="tempAddressObj.slevel_key" :items="outboundList"
                item-text="sl_description" item-value="sl_id" label="Outbound Carrier/Service Level:" dense
                class="ma-0" @change="serviceLvlChange()">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-checkbox v-model="tempAddressObj.sig_required" label="Signature Required" class="pr-3 pl-3 pb-3 ma-0 d-inline-block"
                color="primary" hide-details :disabled="disableSign"></v-checkbox>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <!-- Saturday Delivery -->
              <v-checkbox v-model="tempAddressObj.sat_delivery" label="Saturday Delivery" class="pr-3 pl-3 pb-3 ma-0 d-inline-block"
                color="primary" hide-details :disabled="disableSatDelivery"></v-checkbox>
            </v-col>
          </v-row>
          <v-row v-if="selectedOutboundSL && selectedOutboundSL.show_3rdparty && compName == 'updateCustAddress'" class="pt-2 pb-0">
            <v-col cols="12" sm="12" md="4" lg="4" class="px-5 py-0">
              <v-text-field color="primarytext" persistent-placeholder v-model="tempAddressObj.account_3rd_party"
                class="ma-0" label="3rd Party Account" outlined clearable dense>
              </v-text-field>
            </v-col>
            <v-col v-if="selectedOutboundSL && selectedOutboundSL.show_3rdparty_location && compName == 'updateCustAddress'" cols="12" sm="12" md="4" lg="4" class="px-5 py-0">
              <v-text-field color="primarytext" persistent-placeholder v-model="tempAddressObj.zip_3rd_party"
                class="ma-0" label="3rd Party Bill Zip Code" outlined clearable dense :rules="tempAddressObj.account_3rd_party ? required : []">
              </v-text-field>
            </v-col>
            <v-col v-if="selectedOutboundSL && selectedOutboundSL.show_3rdparty_location && compName == 'updateCustAddress'" cols="12" sm="12" md="4" lg="4" class="px-5 py-0">
              <v-autocomplete :menu-props="{ maxHeight: 150 }" color="primarytext" persistent-placeholder
                outlined v-model="tempAddressObj.countrycode_3rd_party" :items="trimmedCountryData"
                item-text="country" item-value="CountryKey" label="3rd Party Country Code" dense class="ma-0"
                :rules="tempAddressObj.account_3rd_party ? required : []">
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-divider class="pt-5 pb-2"></v-divider>
          <v-row>
            <!-- submit -->
            <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
              <v-btn @click="submitAddress(compName)" color="primarytext" outlined class="mx-auto btn-style"
                elevation="1">
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import EncryptUtility from '../utility/js/encrypt-utility';
import commonApiService from '../common/js/common-api-service';
export default {
  name: 'Address',
  props: {
    compName: String,
    jsonEdit: String,
  },
  data() {
    return {
      max10Rule: [
        (v) => !!v || 'Field is required',
        (v) =>
          (v || '').length <= 10 ||
          'Max Length must be 10 characters or less',
      ],
      stateRule: [(v) => !!v || 'Field is required',
      (v) =>
        /^[a-zA-Z0-9 ]+$/.test(v) ||
        'special character are not allowed'
      ],
      addressRule: [
        (v) => !!v || 'Field is required',
        (v) => v.length <= 35 || 'Maximum 35 characters allowed',
        (v) =>
          /^[a-zA-Z0-9\s.,'#-]*$/.test(v) ||
          'Special characters are not allowed except . , \' # -'
      ],
      address2Rule: [
        (v) => !v || v.length <= 35 || 'Maximum 35 characters allowed',
        (v) =>
          !v || /^[a-zA-Z0-9\s.,'#-]*$/.test(v) ||
          'Special characters are not allowed except . , \' # -'
      ],
      additionalEmailChipRule: (v) => {
        if (!v || v.length === 0) return true;
        if (v.length > 10) return 'Maximum 10 emails are allowed';
        const emailRegex = /^(?!.*\.\.)(?!.*\s)[A-Za-z0-9]+([._%+-]?[A-Za-z0-9]+)*@[A-Za-z0-9]+(-[A-Za-z0-9]+)*(\.[A-Za-z]{2,})+$/;
        return v.every(email => emailRegex.test(email)) || 'Enter a valid email address';
      },
      // Disallow special characters (allow letters, numbers and spaces)
      noSpecialCharRule: (v) => !v || /^[a-zA-Z0-9\s.,'#\- ]+$/.test(v) || 'Special characters are not allowed',
      required: [(v) => !!v || 'Field is required'],
      phoneRules:[
        v => !!v || 'Phone number is required',
        // disallow forward slash '/'
        v => !(v && /\//.test(v)) || 'Slash (/) is not allowed in phone number',
      ],
      intaddrRule: [(v) =>
        /^(?!.*\.\.)(?!.*\s)[A-Za-z0-9]+([._%+-]?[A-Za-z0-9]+)*@[A-Za-z0-9]+(-[A-Za-z0-9]+)*(\.[A-Za-z]{2,})+$/.test(v) ||
        'Enter a valid email address (e.g.,XXXX.XXXX@XXXX.COM)'],
      sameAsCust: false,
      sameAsReturn: false,
      sameAsShip: false,
      showAddFreature: false,
      disableValidate: true,
      disableValidateBtn: false,
      outboundList: [],
      tempAddressObj: {
        store: "",
        fax: "",
        phone2: "",
        Name: "",
        phone1: "",
        intaddr: "",
        company: "",
        country_id: "",
        state: "",
        last: "",
        first: "",
        title: "",
        address2: "",
        address1: "",
        city: "",
        zip: "",
        slevel_key: "",
        cell: "",
        sat_delivery: false,
        sig_required: false,
        additional_email: [],
      },
      countryData: [],
      thirdPartyCountryList: [],
      stateData: "",
      userId: EncryptUtility.localStorageDecrypt('userID'),
      showStateDrop: false,
      disableSign: false,
      disableSatDelivery: false,
    }
  },
  async created() {
    this.route = this.$route.path.replace('/', '');
    this.countryData = this.jsonEdit?.Country_OutInfo?.map(c => ({ ...c, country: c.country?.trim() }));
    let ctryData = await commonApiService.countryListNew(this.userId, '', 1, "get");
    this.thirdPartyCountryList = ctryData?.CountryInfo || [];
    this.outboundList = this.jsonEdit?.SL_OutInfo
    this.serviceLvlChange();
    this.tempAddressObj = JSON.parse(JSON.stringify(this.jsonEdit.Order_Info[0]))
    let initSL = this.outboundList?.find(sl => sl.sl_id === this.tempAddressObj.slevel_key);
    if (initSL) {
      this.tempAddressObj.account_3rd_party = initSL.account_3rd_party || "";
      this.tempAddressObj.zip_3rd_party = initSL.zip_3rd_party || "";
      this.tempAddressObj.countrycode_3rd_party = initSL.countrycode_3rd_party || "";
    }
    this.tempAddressObj.last = this.tempAddressObj.first + " " + this.tempAddressObj.last;
    this.tempAddressObj.additional_email = this.tempAddressObj.additional_email
      ? (typeof this.tempAddressObj.additional_email === 'string'
          ? this.tempAddressObj.additional_email.split(/[;,]/).map(e => e.trim().toLowerCase()).filter(e => e)
          : this.tempAddressObj.additional_email.map(e => typeof e === 'string' ? e.toLowerCase() : e))
      : [];
    this.countrySelected();
  },
  mounted() { },
  destroyed() {
    this.clearAddress();
  },
  computed: {
    selectedOutboundSL() {
      return this.outboundList?.find(sl => sl.sl_id === this.tempAddressObj.slevel_key) || null;
    },
    trimmedCountryData() {
      return this.thirdPartyCountryList.map(c => ({ ...c, country: c.Country?.trim() })) || [];
    },
  },
  methods: {
    checkEmailClear(value) {
      // Clear additional emails when main email is cleared
      if (!value || value.length === 0) {
        this.tempAddressObj.additional_email = [];
      }
    },
    normalizeAdditionalEmails(value) {
      // Normalize to lowercase and remove duplicates including main email
      if (Array.isArray(value) && value.length > 0) {
        const mainEmailLower = this.tempAddressObj.intaddr ? this.tempAddressObj.intaddr.toLowerCase().trim() : '';
        const normalized = value.map(email => typeof email === 'string' ? email.toLowerCase().trim() : email);
        const filtered = normalized.filter(email => email !== mainEmailLower);
        const unique = [...new Set(filtered)];
        if (JSON.stringify(unique) !== JSON.stringify(normalized)) {
          this.$nextTick(() => {
            this.tempAddressObj.additional_email = unique;
          });
        }
      }
    },
    //To get the data of Dropdowns
    async submitAddress(name) {
      if (this.$refs.AddressForm.validate()) {
        if (name == 'updateCustAddress') {
          let tempObj = JSON.parse(JSON.stringify(this.tempAddressObj));
          tempObj.additional_email = Array.isArray(tempObj.additional_email)
            ? tempObj.additional_email.join(';')
            : (tempObj.additional_email || '');
          this.$emit('updatedAPI', tempObj, "updateCustAddress");
        }
        else if (name == 'updateCustAddressPO') {
          let tempObj = JSON.parse(JSON.stringify(this.tempAddressObj));
          tempObj.additional_email = Array.isArray(tempObj.additional_email)
            ? tempObj.additional_email.join(';')
            : (tempObj.additional_email || '');
          this.$emit('updatedAPI', tempObj, "updateCustAddress");
        }
        this.$refs.AddressForm.resetValidation()
        this.$refs.AddressForm.reset()
        this.clearAddress()
      }
    },
    //Clearing Address fields
    clearAddress() {
      this.tempAddressObj = {
        store: "",
        fax: "",
        phone2: "",
        Name: "",
        phone1: "",
        intaddr: "",
        company: "",
        country: "",
        state: "",
        last: "",
        first: "",
        title: "",
        address2: "",
        address1: "",
        city: "",
        zip: "",
        sat_delivery: false,
        sig_required: false,
        additional_email: [],
      }
    },
    //Country Selected
    async countrySelected() {
      this.$nextTick(() => this.$refs.countryAutocomplete?.blur());
      let selected = this.countryData?.find(c => c.country_id === this.tempAddressObj.country_id);
      let countryKey = selected?.country || this.tempAddressObj.country;
      let data1 = await commonApiService.countryListNew(this.userId, countryKey, 2, "get");
      this.stateData = data1.StateInfo;
      if (this.stateData.length !== 0) {
        this.showStateDrop = true;
      } else {
        this.showStateDrop = false;
      }
    },
    //Service Level change
    serviceLvlChange(){
      let carrier = this.outboundList.find((obj)=>obj.sl_id == this.tempAddressObj.slevel_key);
      this.disableSign = carrier.sig_required == 0 ? true: false;
      if(this.disableSign){
        this.tempAddressObj.sig_required = false;
      }      
      this.disableSatDelivery = carrier.sat_delivery == 0 ? true: false;
      if(this.disableSatDelivery){
        this.tempAddressObj.sat_delivery = false;
      }
      this.tempAddressObj.account_3rd_party = carrier.account_3rd_party || "";
      this.tempAddressObj.zip_3rd_party = carrier.zip_3rd_party || "";
      this.tempAddressObj.countrycode_3rd_party = carrier.countrycode_3rd_party || "";
    },
  }
}
</script>
<style scoped>
.v-autocomplete--content {
  max-height: 100px !important;
}
</style>